import { z } from "zod";
import { getBaseFilterOutput } from "@/Schemas/BaseFilterOutput";
import { MyReportsDto, MyReportsDtoSchema } from "@/Schemas/Reports/MyReportsDto";

export const GetMyReportsOutputSchema = getBaseFilterOutput<MyReportsDto>(MyReportsDtoSchema);

export type GetMyReportsOutput = z.infer<typeof GetMyReportsOutputSchema>;